import { useEffect } from "react"
import { useQuery } from "@apollo/client"

import { COACH_TOOLS_API } from "../apolloClient"
import {
  EDUCATION_CPP_OFFERING_QUERY,
  reportCppPurchaseUnavailable,
} from "../utils/educationCppPurchase"
import { getMembershipMobileEducationPurchaseUrl } from "../utils/educationPgmPurchase"

/**
 * Resolves the my.pga.com purchase URL for the member's CPP offering.
 * `unavailable` is true once the lookup finishes without an offering, or
 * fails. Callers show the unavailable message then and never fall back to
 * the legacy checkout, because a missing offering means CPP purchase is
 * misconfigured for this member.
 */
export function useEducationCppPurchaseUrl({ skip = false } = {}) {
  const { data, error, loading } = useQuery(EDUCATION_CPP_OFFERING_QUERY, {
    context: { api: COACH_TOOLS_API },
    fetchPolicy: "network-only",
    errorPolicy: "all",
    skip,
  })

  const url = skip
    ? null
    : getMembershipMobileEducationPurchaseUrl(
        data?.me?.educationCppOffering?.id,
      )
  const unavailable = !skip && !loading && !url

  useEffect(() => {
    if (!unavailable) return
    reportCppPurchaseUnavailable(
      error ?? new Error("No CPP purchase offering for an approved member"),
    )
  }, [unavailable, error])

  return { loading: !skip && loading, unavailable, url }
}
